import services from './module';

const blackList = [
    'transition superseded',
    'Possibly unhandled rejection'
];

function isSpecialError(exception: Error | string) {
    const message = _.isError(exception) ? exception.message : exception;
    return blackList.some((item) => message.includes(item));
}

services.factory('$exceptionHandler', ($log: ng.ILogService) => {
    return ((exception, cause) => {
        if (isSpecialError(exception)) {
            console.info(exception, cause);
        } else {
            if (!options.isProduction && _ && _.notification) {
                _.notification.showError('Exception: ' + exception);
            }
            $log.error(exception, cause);
        }
    }) as ng.IExceptionHandlerService;
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ExceptionHandler.ts